import httpManager from "@/app/shared/utils/httpManager";

/**
 * Obtiene las opciones configuradas para un campo de plantilla.
 *
 * @param {number} portfolioId Identificador de la campaña.
 * @param {string} fieldName Nombre técnico del campo.
 *
 * @return {Promise<Array>} Opciones del campo.
 */
export async function fetchTemplateFieldOptions(portfolioId, fieldName) {
  const response = await httpManager.get(
    `/portfolios/${portfolioId}/template/fields/${fieldName}/options/?limit=2000&offset=0`,
  );

  return response?.data?.results || [];
}
